import { ColorModeScript } from "@chakra-ui/react";
import React, { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import App from "./App";

import AdminCampaigns from "./pages/admin/campaigns";
import AdminUsers from "./pages/admin/users";
import AdminEditCampaign from "./pages/admin/campaignEdit"
import AdminRatings from "./pages/admin/ratings"

import Campaigns from "./pages/brand/campaigns";
import CreateCampaign from "./pages/brand/create_campaign";
import CampaignEvaluation from "./pages/campaignEvaluation";
import Login from "./pages/login";
import LoginBrand from "./pages/loginBrand";
import BrandProfile from "./pages/brand/brand_profile";
import Reporting from "./pages/brand/Reporting";
import UserProfile from "./pages/user_profile";
import NotFound from "./pages/404";
import Account from "./pages/brand/account";
import UserHome from "./pages/userHome";
import Ratings from "./pages/ratings";

import ErrorBoundary from "./ErrorBoundary";

import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";
import {
  createBrowserRouter,
  BrowserRouter,
  RouterProvider,
} from "react-router-dom";
import { ChakraProvider, useColorModeValue, theme } from "@chakra-ui/react";
import "./index.css";

const router = createBrowserRouter([
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/loginBrand",
    element: <LoginBrand />,
  },
  {
    path: "/brandAccount",
    element: <Account />,
  },
  {
    path: "/brand/:brand",            
    element: <BrandProfile />,
  },
  {
    path: "/userProfile",            
    element: <UserProfile />,
  },
  {
    path: "/brandCampaigns",
    element: <Campaigns />,
  },
  {
    path: "/campaign/:brand/:campaign",
    element: <CampaignEvaluation/>,
  },
  {
    path: "/home",
    element: <UserHome/>,
  },
  {
    path: "/brandCampaigns/create",
    element: <CreateCampaign />,
  },
  {
    path: "/ratings",
    element: <Ratings/>,
  },
  {
    path: "/brandCampaigns/reports",
    element: <Reporting/>,
  },
  {
    path: "*",
    element: <NotFound />,
  },
  {
    path: "/admin/campaigns",
    element: <AdminCampaigns />,
  },
  {
    path: "/admin/campaigns/:brand/:campaign",
    element: <AdminEditCampaign />,
  },
  {
    path: "/admin/users",
    element: <AdminUsers />,
  },
  {
    path: "/admin/ratings",
    element: <AdminRatings />,
  },
]);

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  <ErrorBoundary>
    <ColorModeScript />
    <ChakraProvider theme={theme}>
      <RouterProvider router={router} />
    </ChakraProvider>
  </ErrorBoundary>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
